export enum ImageAlignment {
    LEFT = 'left',
    RIGHT = 'right',
  }